module.exports = __webpack_public_path__ + "static/img/contact.acd62c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/contact.png
// module id = H+bF
// module chunks = 1